
import { defineComponent, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { get_franchisee_by_id } from '@/api/jms-model';
import { useStore } from 'vuex';
import { btn_record } from '@/views/profile/basic-franchisee/basic.ts';
import PageModel2 from '@/components/page-model2/index.vue';

export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const activeKey = ref<string>('报单');
    route.meta.title = route.params['name'];
    const current_org = store.getters['user/current_org'];
    const search = reactive({
      current: 1,
      pageSize: 20,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_active: true,
        franchisee_id: Number(route.params['id']),
      },
    });
    const dataList: any = reactive({
      full_name: '',
    });
    get_franchisee_by_id({
      org_id: current_org.id,
      franchisee_ids: Number(route.params['id']),
    }).then((res: any) => {
      Object.assign(dataList, res);
    });

    const tableList = reactive([
      {
        title: '报单',
        search: search,
        modalType: 'company-requestorder',
      },
      {
        title: '下单',
        search: search,
        modalType: 'company-productorder',
      },
      {
        title: '发货',
        search: search,
        modalType: 'company-sendorder',
      },
      {
        title: '撤单',
        search: search,
        modalType: 'company-backorder',
      },
      {
        title: '收款',
        search: search,
        modalType: 'company-franchiseeczrecord',
      },
      {
        title: '加盟商钱包',
        search: search,
        modalType: 'jms-franchiseewallet',
      },
    ]);

    return {
      tableList,
      route,
      activeKey,
      dataList,
      btn_record,
    };
  },
  components: {
    PageModel2,
  },
});
